import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g>
      <path
        d="M73.71 40.52C73.71 40.52 60.15 33.63 56.1 28.9C51.6 23.64 51.8 1 51.8 1H39.37C39.37 1 39.68 23.75 35.07 28.9C30.18 34.36 17.46 40.32 17.46 40.32C23.65 54.9 36.05 58.62 45.58 58.62C55.11 58.62 67.51 55.1 73.71 40.52Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.24 57.42C85.62 45.42 82.03 42.17 77.36 39.82C74.85 38.55 60.27 30.98 60.27 30.98L54.92 24.96L45.59 37.83L36.26 24.96L30.91 30.98C30.91 30.98 16.33 38.55 13.82 39.82C9.15 42.17 5.71 45.82 3.94 57.42C2.11 69.36 2 71.18 2 71.18H89.15C89.16 71.18 88.86 69.47 87.24 57.42Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M30.9004 30.98L37.6204 43.89L42.2904 33.62" stroke={outline} strokeMiterlimit="10" fill={fill} />
      <path d="M60.2601 30.98L53.5401 43.89L48.8701 33.62" stroke={outline} strokeMiterlimit="10" fill={fill} />
      <path
        d="M45.6003 44.0399C46.3293 44.0399 46.9203 43.4489 46.9203 42.7199C46.9203 41.9909 46.3293 41.3999 45.6003 41.3999C44.8713 41.3999 44.2803 41.9909 44.2803 42.7199C44.2803 43.4489 44.8713 44.0399 45.6003 44.0399Z"
        fill="white"
      />
      <path
        d="M45.6003 53.18C46.3293 53.18 46.9203 52.5891 46.9203 51.86C46.9203 51.131 46.3293 50.54 45.6003 50.54C44.8713 50.54 44.2803 51.131 44.2803 51.86C44.2803 52.5891 44.8713 53.18 45.6003 53.18Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.5811"
          y1="39.929"
          x2="45.5811"
          y2="6.9017"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor="#D8A280" />
          <stop offset="0.8447" stopColor="#BC7B55" />
        </linearGradient>
      </defs>
    </g>
  )
}
